(function () {
  'use strict';
  var root = typeof window !== 'undefined' ? window : globalThis;

  // Derive Shopify CDN asset base URL from this script's own src attribute.
  // Used by buildCoverBlueprint to embed a full sticker URL in the blueprint.
  (function () {
    if (root.pctAssetBaseUrl) return;
    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i++) {
      var s = scripts[i].src || '';
      var idx = s.indexOf('pct-cover-blueprint.js');
      if (idx !== -1) { root.pctAssetBaseUrl = s.slice(0, idx); break; }
    }
  }());

  // ── Page dimensions (mm, no bleed) ─────────────────────────────────────
  var PAGE_FRONT_W = 210;
  var PAGE_FRONT_H = 297;
  // Spine width is NOT fixed — it is 20 / 40 / 80 mm based on edition (see editionToSpineWidthMm)
  var PAGE_SPINE_H = 297;
  var PAGE_BACK_W  = 210;
  var PAGE_BACK_H  = 297;

  // Spine widths by edition
  var SPINE_WIDTH_BY_PAGES = { 50: 20, 100: 40, 200: 80 };

  function editionToSpineWidthMm(edition) {
    var match = String(edition || '').match(/^(\d+)/);
    if (!match) return 20;
    var pages = parseInt(match[1], 10);
    if (pages >= 200) return 80;
    if (pages >= 100) return 40;
    return 20;
  }

  // Back cover: content inset (matches cart preview CSS)
  var BACK_LEFT = PAGE_BACK_W * 0.14;               // 29.4 mm
  var BACK_W    = PAGE_BACK_W * (1 - 0.14 - 0.08); // 163.8 mm

  // ── Title colour (matches Liquid pct-cart-book-cover.liquid) ────────────
  function hslToHex(h, s, l) {
    s /= 100; l /= 100;
    var c = (1 - Math.abs(2 * l - 1)) * s;
    var x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    var m = l - c / 2;
    var r, g, b;
    if      (h < 60)  { r = c; g = x; b = 0; }
    else if (h < 120) { r = x; g = c; b = 0; }
    else if (h < 180) { r = 0; g = c; b = x; }
    else if (h < 240) { r = 0; g = x; b = c; }
    else if (h < 300) { r = x; g = 0; b = c; }
    else              { r = c; g = 0; b = x; }
    function ch(v) { return Math.round((v + m) * 255).toString(16).padStart(2, '0'); }
    return '#' + ch(r) + ch(g) + ch(b);
  }

  var TITLE_COLOR_MAP = {
    '#faf0e6': hslToHex(30,  100, 39),
    '#f4f0ea': hslToHex(36,  61,  39),
    '#e6c8c1': hslToHex(10,  78,  28),
    '#d1d1d1': hslToHex(0,   0,   27),
    '#928f68': hslToHex(56,  0,   92),
    '#6a2e35': hslToHex(353, 31,  85),
    '#1a1a1a': hslToHex(0,   0,   65)
  };

  function computeTitleColor(coverHex) {
    var key = String(coverHex || '').toLowerCase().trim();
    return TITLE_COLOR_MAP[key] || '#333333';
  }

  function r4(v) { return Math.round(Number(v) * 10000) / 10000; }

  // ── Blueprint builder ───────────────────────────────────────────────────
  function buildCoverBlueprint(options) {
    options = options || {};
    var coverHex      = String(options.coverHex      || '#f4f0ea');
    var titleColor    = options.titleColor || computeTitleColor(coverHex);
    var title         = String(options.title         || '');
    var year          = String(options.year          || '');
    var stickerAsset  = String(options.stickerAsset  || '');
    var stickerUrl    = String(options.stickerUrl    || '');
    var bookId        = String(options.bookId        || '');
    var storageFolder = String(options.storageFolder || '');
    var bookType      = String(options.bookType      || '');
    var edition       = String(options.edition       || '');
    var spineWidthMm  = Number(options.spineWidthMm) || editionToSpineWidthMm(edition);

    var titleY    = (stickerAsset.indexOf('graduation') !== -1) ? 33 : 25;
    var TITLE_BOX = { x: 10, y: titleY, width: 190, height: 74 };
    var YEAR_BOX  = { x: 10, y: 0,     width: 190, height: 15 };

    // ── Front cover ─────────────────────────────────────────────────────
    // Sticker is placed FIRST so it renders behind title and year
    var frontObjects = [];

    if (stickerAsset) {
      frontObjects.push({
        type: 'image',
        role: 'sticker',
        asset: stickerAsset,
        url: stickerUrl || null,
        boxMm: { x: 0, y: 0, width: PAGE_FRONT_W, height: PAGE_FRONT_H }
      });
    }

    if (title) {
      frontObjects.push({
        type: 'text',
        role: 'title',
        text: title.toUpperCase(),
        font: 'Bowlby One SC',
        fontSizePt: 'auto',
        color: titleColor,
        align: 'center',
        letterSpacingEm: 0.005,
        boxMm: { x: r4(TITLE_BOX.x), y: r4(TITLE_BOX.y), width: r4(TITLE_BOX.width), height: r4(TITLE_BOX.height) }
      });
    }

    if (year) {
      frontObjects.push({
        type: 'text',
        role: 'year',
        text: year,
        font: 'Bowlby One SC',
        fontSizePt: 'auto',
        color: titleColor,
        align: 'center',
        letterSpacingEm: 0.04,
        boxMm: { x: r4(YEAR_BOX.x), y: 'after-title:8', width: r4(YEAR_BOX.width), height: r4(YEAR_BOX.height) }
      });
    }

    // ── Spine ───────────────────────────────────────────────────────────
    var spineLabel  = [title, year].filter(Boolean).join(' ').toUpperCase();

    // ── Back cover ──────────────────────────────────────────────────────
    var backObjects = [
      {
        type: 'text',
        role: 'quote',
        text: '“Some journeys stay with us forever”',
        font: 'Bowlby One SC',
        fontSizePt: 'auto',
        color: titleColor,
        align: 'center',
        boxMm: { x: r4(BACK_LEFT), y: 120, width: r4(BACK_W) }
      },
      {
        type: 'text',
        role: 'attribution',
        text: '~ Pictoírel',
        font: 'Bowlby One SC',
        fontSizePt: 'ratio:quote:0.60',
        color: titleColor,
        align: 'center',
        boxMm: { x: r4(BACK_LEFT), y: 'after-quote:6', width: r4(BACK_W) }
      },
      {
        type: 'text',
        role: 'copyright',
        text: '©2026 Pictoirel.com. All rights reserved.',
        font: 'Inter',
        fontSizePt: 8,
        color: titleColor,
        align: 'left',
        boxMm: { x: 12, y: 279.7, width: 186 }
      }
    ];

    return {
      version: 1,
      bookId: bookId,
      bookType: bookType,
      storageFolder: storageFolder,
      unit: 'mm',
      createdAt: new Date().toISOString(),
      edition: edition,
      spineWidthMm: spineWidthMm,
      coverHex: coverHex,
      titleColor: titleColor,
      title: title,
      year: year,
      stickerAsset: stickerAsset,
      pages: [
        {
          pageIndex: 1,
          type: 'front',
          widthMm: PAGE_FRONT_W,
          heightMm: PAGE_FRONT_H,
          background: { type: 'solid', color: coverHex },
          objects: frontObjects
        },
        {
          pageIndex: 2,
          type: 'spine',
          widthMm: spineWidthMm,
          heightMm: PAGE_SPINE_H,
          edition: edition,
          background: { type: 'solid', color: coverHex },
          objects: spineLabel ? [{
            type: 'text',
            role: 'spine-label',
            text: spineLabel,
            font: 'Bowlby One SC',
            fontSizePt: 'auto',
            color: titleColor,
            align: 'center',
            letterSpacingEm: 0.02,
            rotation: -90,
            boxMm: { x: 0, y: 0, width: spineWidthMm, height: PAGE_SPINE_H }
          }] : []
        },
        {
          pageIndex: 3,
          type: 'back',
          widthMm: PAGE_BACK_W,
          heightMm: PAGE_BACK_H,
          background: { type: 'solid', color: coverHex },
          objects: backObjects
        }
      ]
    };
  }

  // ── Public API ──────────────────────────────────────────────────────────
  root.PictoirelCoverBlueprint = {
    buildCoverBlueprint: buildCoverBlueprint,
    computeTitleColor:   computeTitleColor
  };

})();
